import { get, post, del } from "services/api-client";

const featureService = {
  getClientFeatures: (clientId) => get(`/feature/client/${clientId}`),

  getFeaturesAsSelectListItems: () => get("/feature/client/select-list"),

  createClientFeature: (data) => post("/feature/client/create", data),

  deleteClientFeature: (clientFeatureId) => del(`/feature/client/${clientFeatureId}/delete`)
};

export default featureService;